// src/services/loaderService.js
let listeners = [];

export const showLoader = () => {
    listeners.forEach((cb) => cb(true));
};

export const hideLoader = () => {
    listeners.forEach((cb) => cb(false));
};

export const subscribeLoader = (cb) => {
    listeners.push(cb);
    return () => {
        listeners = listeners.filter((fn) => fn !== cb);
    };
};
